import { SelectedSideOrdersT } from '@features/orderForm/stepSelectSideOrders/services/redux/stepSelectSideOrders.slice';

export const createSideOrdersArray = (
  data: Record<
    string,
    Record<string, Record<number, { amount: number; name: string }>>
  >
) => {
  const sideOrdersArray: string[] = [];
  Object.values(data)
    .map(days =>
      Object.values(
        days['sideOrders'] as Record<number, { amount: number; name: string }>
      )
    )
    .forEach(sideOrders =>
      sideOrders.forEach(possibleSideOrder => {
        if (possibleSideOrder.amount) {
          sideOrdersArray.push(possibleSideOrder.name);
        }
      })
    );
  return [...new Set(sideOrdersArray)];
};

export const parseSideOrdersObjectToArray = (
  sideOrdersObject: SelectedSideOrdersT
) => {
  // it's actually not 'string' but 'SideOrderIdT', but Object.keys don't understand it
  const arr: Array<Array<string>> = [];
  // eslint-disable-next-line array-callback-return
  Object.values(sideOrdersObject).map(sideOrder => {
    arr.push(Object.keys(sideOrder));
  });

  return [...new Set(arr.flat())];
};
